import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { AddRoomButton } from "../../../../components/add-room/styled.js";
export const AccommodationPanelWrapper = styled.div.withConfig({
    displayName: "styled__AccommodationPanelWrapper",
    componentId: "sc-33182c5d-0"
})`
	overflow: hidden;
	${FlexMixin({
    direction: 'column',
    justify: 'space-between'
})}
	flex: 1 1 auto;
`;
export const AccommodationPanelContent = styled.div.withConfig({
    displayName: "styled__AccommodationPanelContent",
    componentId: "sc-33182c5d-1"
})`
	flex: 1 1 auto;
	${FlexMixin({
    direction: 'column'
})}
	overflow-y: auto;
	background-color: ${({ theme  })=>theme.bodyBgColor};
`;
export const AccommodationPanelBody = styled.div.withConfig({
    displayName: "styled__AccommodationPanelBody",
    componentId: "sc-33182c5d-2"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 16px;
`;
export const AccommodationPanelFooter = styled.div.withConfig({
    displayName: "styled__AccommodationPanelFooter",
    componentId: "sc-33182c5d-3"
})`
	gap: 8px;

	& > button {
		color: ${({ theme  })=>theme.colors.primary.light};
		${FontMixin({
    size: 'base',
    weight: 'medium'
})}

		&:hover {
			color: ${({ theme  })=>theme.colors.primary.base};
		}
	}

	${AddRoomButton} {
		padding: 16px;
		color: ${({ theme  })=>theme.colors.primary.light};
		text-transform: uppercase;
		${FontMixin({
    size: 'medium',
    weight: 'medium',
    height: 'medium'
})}
	}
`;

//# sourceMappingURL=styled.js.map